export default __webpack_public_path__ + "static/media/shoe-man.7ecd5bb9.png";